import {ChildNodeProps} from "../parser/definition/types/ChildNodeProps";
import {compileDictionary} from "./utils/compileDectionary";

// TODO: Change nodeName to factoryRef?
export function compileChildNodeProps<I>(
  childNodeProps: ChildNodeProps<I>
): string {
  const {
    nodeName,
    params
  } = childNodeProps;
  return `{
  "nodeName": ${JSON.stringify(nodeName)},
  "params": ${compileDictionary(params as any)}
}`;
}
